module.exports = __webpack_public_path__ + "img/ch3.0ad23be5.jpg";